// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0b5e089","239":"27c2964f","453":"54872a6c","563":"80e01447"}[chunkId] + ".chunk.js";
};